export default __webpack_public_path__ + "static/media/striped.d3b613bd.webp";